import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  image?: string;
}
export function TestimonialCard({
  name,
  role,
  content,
  image
}: TestimonialCardProps) {
  return <div className="bg-gray-900 border border-gray-800 p-6 rounded-xl" data-id="element-27">
      <div className="flex gap-1 mb-4" data-id="element-28">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-29" />)}
      </div>
      <p className="text-gray-300 mb-6 italic" data-id="element-30">"{content}"</p>
      <div className="flex items-center gap-3" data-id="element-31">
        <div className="w-10 h-10 rounded-full bg-gray-700 flex items-center justify-center text-white font-bold" data-id="element-32">
          {name.charAt(0)}
        </div>
        <div data-id="element-33">
          <p className="text-white font-bold text-sm" data-id="element-34">{name}</p>
          <p className="text-gray-500 text-xs" data-id="element-35">{role}</p>
        </div>
      </div>
    </div>;
}